export default "__VITE_PUBLIC_ASSET__6f730a18__"